import { ComponentType } from '@angular/cdk/overlay';
import { Component, inject } from '@angular/core';
import { ISidenavItemDescriptor, ISidenavItemProvider } from 'core';
import { SidenavItem } from 'design-system';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'task-task-sidenav-item',
  imports: [
    SidenavItem
  ],
  templateUrl: './task-sidenav-item.html',
  styleUrl: './task-sidenav-item.scss',
})
export class TaskSidenavItem extends ISidenavItemProvider {
  private http = inject(HttpClient);
  private router = inject(Router);

  override describe(): ISidenavItemDescriptor {
    return { providerName: 'Task' };
  }

  override evaluate(): ComponentType<any> {
    return TaskSidenavItem;
  }

  // Count per il badge
  count: any;

  ngOnInit() {
    // Recupero il valore del count
    this.updateCount();

    // Aggiorno il valore del count ad ogni cambio pagina
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateCount();
    });
  }

  updateCount() {
    this.http.get<number>('api/taskapprovativi/count-my-tasks').subscribe({
      next: (value) => {
        this.count = value;
      }
    });
  }
}
